import { Button, ButtonProps, Tooltip } from '@mantine/core'
import React from 'react'

import FormSpy from '../FormSpy'
import useForm from './useForm'

type SubmitButtonProps = {
  ignoreValidation?: boolean
} & ButtonProps

const SubmitButton = (props: SubmitButtonProps): React.ReactElement => {
  const { children, ignoreValidation = false, ...rest } = props

  const form = useForm()

  return (
    <FormSpy subscription={{ valid: true, validating: true }}>
      {({ valid, validating }) => (
        <div>
          <Tooltip
            disabled={!(!ignoreValidation && (!valid || validating))}
            label={i18n.t(
              `fill_all_fields_form_btn`,
              `Bitte füllen Sie alle Felder aus und korrigieren Sie alle Fehler`,
            )}
          >
            <div>
              <Button
                color="blue"
                variant="filled"
                {...rest}
                onClick={form.submit}
                disabled={!ignoreValidation && (!valid || validating)}
              >
                {children}
              </Button>
            </div>
          </Tooltip>
        </div>
      )}
    </FormSpy>
  )
}

export default SubmitButton
